import React from 'react';
import styles from './FilterMenu.module.scss';
import ChevronIcon from './ChevronIcon';
import { useFacetTitle } from '../utils/getFacetTitle';

const FilterMenuItem = ({ facet, onClick }) => {
  const filterTitle = useFacetTitle(facet);

  if (!filterTitle) return null;
  return (
    <button className={styles.menuItem} onClick={() => onClick(facet)}>
      <span className={styles.menuLabel}>{filterTitle}</span>
      <span className={styles.iconWrapper}>
        <ChevronIcon />
      </span>
    </button>
  );
};

export default FilterMenuItem;
